import { optimized } from "../../lib/img";
const CDN = "https://static.prod-images.emergentagent.com/jobs/9ba007ac-22d1-4753-8f02-6aa38496beba/images/";

export const STUDY_IMAGES = {
  canada: optimized(`${CDN}c7874f0f6f7ddce0d502d4e3a3aa9b8059a71d886264b852bb742fc6b102d3b7.jpeg`),
  "united-kingdom": optimized(`${CDN}8f776ac2f27e2ccc610f811b7dc12ab8f5d8f1d48fcd37ff8733e096f5ddd1cf.jpeg`),
  australia: optimized(`${CDN}c0db1d3c9cf65122d98062b4394d7f73198ef52c03eae12708fa5b9f716ce121.jpeg`),
  "united-states": optimized(`${CDN}40f653103a2c68f6a09e147ef51ae6a78b5585b450ee966e2f1836163a5ca68b.jpeg`),
  singapore: optimized(`${CDN}587894cc0ac8810a0836419af753464372254fea63d3df0299c2f598cff428a8.jpeg`),
  japan: optimized(`${CDN}d07d6fb444af8490f729b0555fd0b5b5f166dc9b35cf7cba978f7ce58945b047.jpeg`),
};

export const WORK_IMAGES = {
  "united-kingdom": optimized(`${CDN}2a7af594c265adb7edadc3022ae5e88a07337721c475853f056be9e4a530de4d.jpeg`),
  canada: optimized(`${CDN}d40116aecbb2df563c59565f80f02d5ecba8e415b2fbd5861bd3323a32d850f8.jpeg`),
  australia: optimized(`${CDN}6c534e32ab362501fb0e5393ffd5d1f20cd6619628cb087a700e2e0717b60a9f.jpeg`),
  "united-arab-emirates": optimized(`${CDN}008b148ffeac7c9117f9b4a6869b5c961ad82a27d0230a868b8627d241e04d5b.jpeg`),
  singapore: optimized(`${CDN}a5948edb1d8617c8242291fc3323e4cb9d20e4832a7dd59bea9d06a361e4546d.jpeg`),
  "united-states": optimized(`${CDN}674b48ac51186717ee35bb443edd404c839d27b48fe3e06103b7cd489391f814.jpeg`),
};

export const CAMPUS_IMAGES = [
  optimized(`${CDN}a97b2affc2eb707c79903d80cf8fd437bb7c666b9c135f42c1a6fc94af34bbd7.jpeg`),
  optimized(`${CDN}6690fbce46287c4d592c73950fac65fb94d49f78c62c89c9085d30ab7e22a306.jpeg`),
  optimized(`${CDN}2f30c08a95a964f352a046d67c4b216bc61d7b0dde03b260d4c697fbdfd7ca77.jpeg`),
  optimized(`${CDN}5f5d23f38a3c6334d1056576c7715e9866f7b29e62d7ea24956816a7cace04a8.jpeg`),
  optimized(`${CDN}83781c7e111463c8e23611bcdd4fefa16137a335a9d5a5e35b52c36c3806c3f8.jpeg`),
  optimized(`${CDN}a8d408c30979bfd6aa7442b70d33b1d6964919bcc304bf619ef4e3966bfb6177.jpeg`),
];
export const campusFor = (i) => { const n = CAMPUS_IMAGES.length; return Array.from({ length: n }, (_, k) => CAMPUS_IMAGES[(i + k) % n]); };
